<template>
  <div>
    <div>开打控制台</div>
    <button @click="closeLog">关闭控制台</button>
  </div>
</template>

<script>
export default {
  name: 'vconsolelog',
  mounted () {
    this.log()
  },
  methods: {
    log () {
      localStorage.setItem('__open_vconsole', 'true')
    },
    closeLog () {
      localStorage.removeItem('__open_vconsole')
    }
  }
}
</script>

<style scoped>

</style>
